export var AvatarConfig;
(function (AvatarConfig) {
    AvatarConfig["NONE"] = "none";
    AvatarConfig["INCOMING"] = "incoming";
    AvatarConfig["OUTGOING"] = "outgoing";
    AvatarConfig["BOTH"] = "both";
})(AvatarConfig || (AvatarConfig = {}));
export var TitleConfig;
(function (TitleConfig) {
    TitleConfig["NONE"] = "none";
    TitleConfig["INCOMING"] = "incoming";
    TitleConfig["OUTGOING"] = "outgoing";
    TitleConfig["BOTH"] = "both";
})(TitleConfig || (TitleConfig = {}));
//# sourceMappingURL=MessageDisplayConfig.js.map